<template>
  <SysMenu
    texto_titulo="Selecione os anos"
    texto_botao_aceitar="aplicar"
    :max_width="250"
    :min_width="250"
    txt_ativador="ano"
    icone_personalizado=""
    @confirmar-menu="aplicarFiltros()"
  >
    <v-radio-group v-model="radio_selecionado" column>
      <v-radio label="Selecionar todos" value="sel" />
      <v-radio label="Desmarcar todos" value="des" />
    </v-radio-group>

    <v-divider class="mb-5" />

    <v-checkbox
      v-for="(m, i) in anos_fixos"
      :key="i"
      v-model="anos"
      :label="`${m}`"
      :value="m"
      @click="radio_selecionado = null"
    ></v-checkbox>
  </SysMenu>
</template>

<script>
import SysMenu from '@/components/utils/SysMenu.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  components: { SysMenu },
  data: () => ({
    anos_fixos: [],
    anos: [],
    radio_selecionado: null
  }),
  computed: {
    ...mapGetters({
      GET_DADOS_GRAFICO_TABELA: 'EventoSazonalFinal/GET_DADOS_GRAFICO_TABELA',
    })
  },
  methods: {
    ...mapMutations({
      setFiltrosGraficoTabela: 'EventoSazonalFinal/SET_FILTROS_GRAFICO_TABELA',
    }),
    aplicarFiltros() {
      this.$store.dispatch('EventoSazonalFinal/buscarDadosGrafico');
      this.$store.dispatch('EventoSazonalFinal/buscarDadosTabela');
    }
  },
  watch: {
    GET_DADOS_GRAFICO_TABELA(valor) {
      if (valor.anos.length > 0 && this.anos_fixos.length == 0) {
        this.anos_fixos = valor.anos;
        this.anos = valor.anos;
      }
    },
    anos(valor) {
      this.setFiltrosGraficoTabela({ anos: valor });
    },
    radio_selecionado(valor) {
      switch (valor) {
        case 'sel':
          this.anos = this.anos_fixos;
          break;

        case 'des':
          this.anos = [];
          break;
      }
    }
  },
}
</script>

<style>

</style>
